import { makeStyles } from "@material-ui/core/styles";

/**
 * With the status in the page header (job and invoice pages, in the beta), the actions get the whole row: one even
 * group, equal widths, one shared tap-friendly height and the same gaps and corners, whatever each button sets for
 * itself. Their wording, icons and colours are untouched.
 */
// The lightest green white text still reads on (4.5:1), and still well apart from the invoice green beside it.
export const READABLE_REVIEW_GREEN = "#058762";

export const useActionGroupStyles = makeStyles({
  group: {
    flex: 1,
    display: "grid",
    gridAutoFlow: "column",
    gridAutoColumns: "1fr",
    gap: 8,
    padding: 5,
    // Every action renders a button; matched by tag, since one sits in its own theme with generated class names.
    "&& > button, && > button:hover, && > button:active, && > button.Mui-focusVisible": {
      width: "100%",
      // Still a full tap target (44px+) at 20% under the original height.
      minHeight: 47,
      paddingTop: 1,
      paddingBottom: 1,
      margin: 0,
      borderRadius: 8,
      // Raised, not flat: a drop shadow, a light top edge and a slight top-to-bottom shade over each button's colour.
      backgroundImage: "linear-gradient(rgba(255,255,255,0.12), rgba(0,0,0,0.10))",
      boxShadow: "0 3px 6px rgba(0,0,0,0.5), inset 0 1px 0 rgba(255,255,255,0.25)",
    },
    // Tighter lines and a smaller icon keep three-line labels from setting the row's height.
    "&& > button svg": { fontSize: 20 },
    "&& > button div > span": { lineHeight: 1.25 },
    // One text colour for every action, whatever its own theme picks; a disabled one keeps its greyed-out look.
    "&& > button:not(.Mui-disabled)": { color: "#fff" },
    "&& > button.Mui-disabled": { backgroundImage: "none", boxShadow: "none" },
    // An action with nothing to offer renders an empty placeholder; it must not hold a slot.
    "& > div:empty": { display: "none" },
  },
});
